import { render, staticRenderFns } from "./hi-base.vue?vue&type=template&id=d43036de"
import script from "./hi-base.vue?vue&type=script&lang=ts"
export * from "./hi-base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports